import ContentEncryptionService from './ContentEncryptionService.js';

export default async () => {
    const message = JSON.stringify({
        tenant_id: ContentEncryptionService.getEncryptionKeyIvSeed().tenant_id,
        issue_id: ContentEncryptionService.getEncryptionKeyIvSeed().issue_id,
        iv_seed: import.meta.env.VITE_CONTENT_ENCRYPTION_IV,
    });
    const encoder = new TextEncoder();
    const data = encoder.encode(message);
    const hash = await crypto.subtle.digest('SHA-256', data);

    return new Uint8Array(hash).slice(0, 12);
};
